import script from "./TopMerchantsChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopMerchantsChart.vue?vue&type=script&setup=true&lang=ts"

import "./TopMerchantsChart.vue?vue&type=style&index=0&id=14340ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14340ca0"]])

export default __exports__